var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-checkbox',{attrs:{"input-value":_vm.coursePhotoConsent,"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.toggle($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }